import { useSearchParams } from 'react-router';
import type { CandidateInfoTab } from '../types';

const TAB_SEARCH_PARAM = 'tab';
const DEFAULT_TAB: CandidateInfoTab = 'general';

const isCandidateInfoTab = (value: string | null): value is CandidateInfoTab =>
  value === 'general' || value === 'profiles';

export const useCandidateInfoTab = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabSearchParam = searchParams.get(TAB_SEARCH_PARAM);
  const activeTab = isCandidateInfoTab(tabSearchParam)
    ? tabSearchParam
    : DEFAULT_TAB;

  const handleTabChange = (value: string) => {
    if (!isCandidateInfoTab(value)) {
      return;
    }

    setSearchParams(currentSearchParams => {
      const nextSearchParams = new URLSearchParams(currentSearchParams);
      nextSearchParams.set(TAB_SEARCH_PARAM, value);

      return nextSearchParams;
    });
  };

  return { activeTab, handleTabChange };
};
